import { useEffect } from "react";
import { useAddressGenerator } from "../hooks";
import { useOnboard } from "../hooks/useOnboard";

function AddressGenerator(): JSX.Element {
  const { setAccountData } = useOnboard();
  const {
    mnemonic,
    setMnemonic,
    addressIndex,
    setAddressIndex,
    result,
    loading,
    generateAddress,
    isReady,
  } = useAddressGenerator();

  // Save generated address and mnemonic to useOnboard (single source of truth) when generation succeeds
  useEffect(() => {
    if (result?.success && result.address && mnemonic) {
      setAccountData(mnemonic, result.address);
    }
  }, [result, mnemonic, setAccountData]);

  return (
    <div className="component">
      <h3>Address Generator</h3>
      <p>Generate Ethereum addresses from mnemonic phrases</p>

      <div className="form-group">
        <label htmlFor="mnemonic">Mnemonic Phrase:</label>
        <textarea
          id="mnemonic"
          value={mnemonic}
          onChange={(e) => setMnemonic(e.target.value)}
          placeholder="Enter your mnemonic phrase..."
          rows={3}
        />
      </div>

      <div className="form-group">
        <label htmlFor="addressIndex">Address Index:</label>
        <input
          id="addressIndex"
          type="number"
          value={addressIndex}
          onChange={(e) => setAddressIndex(parseInt(e.target.value) || 0)}
          min="0"
          max="1000"
        />
      </div>

      <button
        className="button"
        onClick={generateAddress}
        disabled={loading || !isReady}
      >
        {loading ? "Generating..." : "Generate Address"}
      </button>

      {result && (
        <div className={`output ${result.success ? "success" : "error"}`}>
          {result.success ? (
            <>
              <strong>Generated Address:</strong>
              <br />
              {result.address}
              <br />
              <br />
              <strong>Details:</strong>
              <br />
              Index: {result.index}
              <br />
              Mnemonic: {result.mnemonic}
            </>
          ) : (
            <>
              <strong>Error:</strong>
              <br />
              {result.error}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default AddressGenerator;
